/* ORIAVI performance loader — desktop dropdown/mega-menu core on first menu interaction. */
(() => {
  'use strict';

  const currentScript = document.currentScript;
  const currentSrc = currentScript && currentScript.src;
  if (!currentSrc) return;

  const coreUrl = new URL(currentSrc, window.location.href);
  coreUrl.pathname = coreUrl.pathname.replace(/menu-dropdown\.js$/, 'menu-dropdown-core.js');
  coreUrl.search = '';

  const coreSrc = coreUrl.toString();
  const desktop = window.matchMedia('(min-width: 990px)');
  const navSelector = '.header__inline-menu';
  let loadPromise;

  const syncActiveMenu = () => {
    const hovered = document.querySelector(`${navSelector} dropdown-menu:hover, ${navSelector} mega-menu:hover`);
    if (hovered && typeof hovered.handleMouseover === 'function') {
      hovered.handleMouseover();
    }

    const activeElement = document.activeElement;
    const focused = activeElement && activeElement.closest
      ? activeElement.closest('dropdown-menu, mega-menu')
      : null;

    if (
      focused &&
      focused.closest(navSelector) &&
      typeof focused.handleFocusIn === 'function'
    ) {
      focused.handleFocusIn({ target: activeElement });
    }
  };

  const cleanupPrimers = () => {
    document.removeEventListener('pointerover', prime, true);
    document.removeEventListener('focusin', prime, true);
    document.removeEventListener('touchstart', prime, true);
  };

  const loadCore = () => {
    if (customElements.get('dropdown-menu') && customElements.get('mega-menu')) {
      cleanupPrimers();
      requestAnimationFrame(syncActiveMenu);
      return Promise.resolve();
    }

    if (loadPromise) return loadPromise;

    loadPromise = new Promise((resolve, reject) => {
      const finish = () => {
        cleanupPrimers();
        requestAnimationFrame(syncActiveMenu);
        resolve();
      };

      const existing = document.querySelector('script[data-oriavi-menu-dropdown-core]');
      if (existing) {
        if (existing.dataset.loaded === 'true') {
          finish();
        } else {
          existing.addEventListener('load', finish, { once: true });
          existing.addEventListener('error', reject, { once: true });
        }
        return;
      }

      const script = document.createElement('script');
      script.src = coreSrc;
      script.async = false;
      script.dataset.oriaviMenuDropdownCore = 'true';
      script.addEventListener('load', () => {
        script.dataset.loaded = 'true';
        finish();
      }, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });

    return loadPromise;
  };

  function prime(event) {
    if (!desktop.matches || !event.target || !event.target.closest) return;
    if (!event.target.closest(navSelector)) return;
    loadCore();
  }

  window.oriaviLoadDesktopMenu = loadCore;

  if (window.Shopify && window.Shopify.designMode) {
    loadCore();
    return;
  }

  document.addEventListener('pointerover', prime, { capture: true, passive: true });
  document.addEventListener('focusin', prime, true);
  document.addEventListener('touchstart', prime, { capture: true, passive: true });
})();
